import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Youtube,
  Mail,
  Phone,
} from "lucide-react";
import { Link } from "react-router-dom"; // Correct import

export default function Footer() {
  return (
    <footer className="bg-themeColor text-white">
      <div className="w-[85%] mx-auto px-4 py-16">
        {/* Logo + tagline row */}
        <div className="mb-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <img src="/assets/logo.png" alt="Flex Management System" className="h-12 w-auto brightness-0 invert mb-3" />
            <p className="font-popinsRegular text-white/70 text-sm max-w-xs leading-relaxed">
              The property management platform built for small bay &amp; flex industrial operators across the USA.
            </p>
          </div>
          <Link
            to="/request-demo"
            className="self-start md:self-auto inline-flex items-center gap-2 bg-btnColor hover:bg-btnColor/90 text-white font-popinsSemiBold text-sm px-6 py-3 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Book a Free Demo
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Product Column */}
          <div>
            <h3 className="font-popinsSemiBold text-sm uppercase tracking-widest text-white/50 mb-5">
              Product
            </h3>
            <ul className="space-y-3 font-popinsRegular text-sm text-white/80">
              <li>
                <Link to="/product/landlord" className="hover:text-white transition-colors duration-200">
                  Landlord Dashboard
                </Link>
              </li>
              <li>
                <Link to="/product/tennant" className="hover:text-white transition-colors duration-200">
                  Tenant Dashboard
                </Link>
              </li>
              {/* <li>
                <Link to="" className="">
                  Request Demo
                </Link>
              </li> */}
            </ul>
            <div className="flex space-x-4 mt-8">
              <Link to="" aria-label="Facebook">
                <Facebook size={18} className="text-white/60 hover:text-white transition-colors duration-200" />
              </Link>
              <Link to="" aria-label="Twitter">
                <Twitter size={18} className="text-white/60 hover:text-white transition-colors duration-200" />
              </Link>
              <Link to="" aria-label="Instagram">
                <Instagram size={18} className="text-white/60 hover:text-white transition-colors duration-200" />
              </Link>
              <Link to="" aria-label="LinkedIn">
                <Linkedin size={18} className="text-white/60 hover:text-white transition-colors duration-200" />
              </Link>
              <Link to="" aria-label="YouTube">
                <Youtube size={18} className="text-white/60 hover:text-white transition-colors duration-200" />
              </Link>
            </div>
          </div>

          {/* Features Column */}
          <div>
            <h3 className="font-popinsSemiBold text-sm uppercase tracking-widest text-white/50 mb-5">
              Features
            </h3>
            <ul className="space-y-3 font-popinsRegular text-sm text-white/80">
              <li>
                <Link to="/features/tenant-management" className="hover:text-white transition-colors duration-200">
                  Tenant Management
                </Link>
              </li>
              <li>
                <Link to="/features/maintenance-requests" className="hover:text-white transition-colors duration-200">
                  Maintenance Requests
                </Link>
              </li>
              <li>
                <Link to="/features/property-unit-creation" className="hover:text-white transition-colors duration-200">
                  Property &amp; Unit Creation
                </Link>
              </li>
              <li>
                <Link to="/features/lease-contracts" className="hover:text-white transition-colors duration-200">
                  Lease Contracts
                </Link>
              </li>
              <li>
                <Link to="/features/maintenance-request-summary" className="hover:text-white transition-colors duration-200">
                  Maintenance Summary
                </Link>
              </li>
              <li>
                <Link to="/features/property-summary" className="hover:text-white transition-colors duration-200">
                  Property Summary
                </Link>
              </li>
              <li>
                <Link to="/features/broadcast" className="hover:text-white transition-colors duration-200">
                  Broadcast
                </Link>
              </li>
              <li>
                <Link to="/features/lease-reminders" className="hover:text-white transition-colors duration-200">
                  Lease Reminders
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-popinsSemiBold text-sm uppercase tracking-widest text-white/50 mb-5">
              Company
            </h3>
            <ul className="space-y-3 font-popinsRegular text-sm text-white/80">
              <li>
                <Link to="/why-flex" className="hover:text-white transition-colors duration-200">
                  Why Flex
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="hover:text-white transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/package" className="hover:text-white transition-colors duration-200">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/request-demo" className="hover:text-white transition-colors duration-200">
                  Request a Demo
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="font-popinsSemiBold text-sm uppercase tracking-widest text-white/50 mb-5">
              Contact
            </h3>
            <ul className="space-y-4 font-popinsRegular text-sm text-white/80">
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 flex-shrink-0 text-white/50" />
                <a href="mailto:support@theflexmanager.com" className="hover:text-white transition-colors duration-200">
                  support@theflexmanager.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 flex-shrink-0 text-white/50" />
                <a href="tel:18883801955" className="hover:text-white transition-colors duration-200">
                  1-888-380-1955
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright Section */}
        <div className="mt-14 font-popinsMedium text-xs text-white/50 pt-6 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-3">
          <p>© 2025 Flex Management System. All rights reserved.</p>
          <p className="flex gap-3 mt-2 md:mt-0">
            <Link to="/terms-condition" className="hover:text-white transition-colors duration-200">
              Terms &amp; Conditions
            </Link>
            <span>|</span>
            <Link to="/privacy-policy" className="hover:text-white transition-colors duration-200">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
